import { useEffect } from 'react';
import { PrimaryRemitReport } from 'src/apis/remit-reporting/types';
import { useAxios } from 'src/hooks/use-axios';
import { handleRequestError } from 'src/utils/axios-config';

export function usePrimaryRemitReportHistory(tradeId: string) {
  const reports = useAxios(
    (axios, signal) =>
      axios.request<PrimaryRemitReport[]>({
        signal,
        url: `${PRISMA_CONFIG.remitReporting}/api/platform/primary-reports/${tradeId}`,
        method: 'GET',
      }),
    {
      neededOnPageLoad: true,
      onError(error) {
        const [_, report] = handleRequestError(error, () => {});

        if (report) reportError(error);

        return error;
      },
    }
  );

  const { execute, setResponse, refresh, ...restReportsRequest } = reports;

  useEffect(() => {
    if (PRISMA_CONFIG.remitReporting != null) execute();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tradeId]);

  if (PRISMA_CONFIG.remitReporting == null) return;

  return restReportsRequest;
}

export type RemitPrimaryReportHistoryRequest = ReturnType<
  typeof usePrimaryRemitReportHistory
>;
